module.exports = __webpack_public_path__ + "static/media/productBanner.0dcf1d16.png";